import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { RegionList } from "../region/RegionList";

export const RegionPage: FC = () => {
	return (
		<Routes>
			<Route index element={<RegionList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
